import DeleteIcon from '@mui/icons-material/Delete';
import ModeEditOutlineIcon from '@mui/icons-material/ModeEditOutline';
import { GridActionsCellItem } from '@mui/x-data-grid';

import TableActionButtons from '../../components/shared/TableActionButtons/TableActionButtons';

const useCarProductionTimeTableColumns = (
  deleteItem,
  editItem,
  apiRef,
  columnPermissions = {},
) => {
  const { canEdit = false, canDelete = false } = columnPermissions;
  const canViewActions = canEdit || canDelete;

  const columnsData = [
    {
      field: 'title',
      headerName: 'عنوان',
      flex: 1,
      minWidth: 120,
      resizable: true,
      editable: false,
      renderCell: params => {
        apiRef.current = params.api;
        return params.row.title;
      },
    },

    ...(canViewActions
      ? [
          {
            field: 'actions',
            headerName: 'عملیات',
            type: 'actions',
            flex: 0.5,
            align: 'right',
            minWidth: 200,

            getActions: params =>
              [
                canEdit ? (
                  <TableActionButtons
                    key={10}
                    buttons={[
                      {
                        label: 'ویرایش',
                        Icon: ModeEditOutlineIcon,
                        onClick: editItem(params.row),
                        color: 'info',
                      },
                    ]}
                  />
                ) : null,
                canDelete ? (
                  <GridActionsCellItem
                    key={1}
                    icon={<DeleteIcon />}
                    label="حذف"
                    onClick={deleteItem(params.row)}
                    showInMenu
                  />
                ) : null,
              ].filter(Boolean),
          },
        ]
      : []),
  ];

  return [columnsData];
};

export default useCarProductionTimeTableColumns;
